import React from "react";
import { Resort } from "../types";
import ResortPicker from "./ResortPicker";

const MapHeader = (props: {
  resort: Resort;
  visibleParks: Set<string>;
  togglePark: (parkTitle: string) => void;
  currentResortKey: string;
  onSelectResort: (resortKey: string) => void;
}) => {
  const { resort, visibleParks, togglePark, currentResortKey, onSelectResort } =
    props;

  return (
    <header className="absolute z-10 mt-4 flex flex-col items-center">
      <div className="flex items-center gap-2">
        <ResortPicker
          currentResortKey={currentResortKey}
          onSelectResort={onSelectResort}
        />
        <h1 className="mx-2 text-center text-md font-bold uppercase leading-6 tracking-[0.2em] text-gray-950">
          Disney Parks Watch Guide
        </h1>
      </div>
      <div className="mt-1.5 flex items-center justify-center gap-2">
        {resort.parks.map((park) => (
          <button
            key={`park-${park.title}`}
            onClick={() => togglePark(park.title)}
            className={`rounded-full bg-white px-4 py-2 text-black drop-shadow transition-opacity hover:opacity-100 ${visibleParks.has(park.title) ? "opacity-100" : "opacity-50 grayscale"}`}
          >
            <img src={park.logo} alt={`${park.title} logo`} className="h-4" />
          </button>
        ))}
      </div>
    </header>
  );
};

export default MapHeader;
